export const END_POINT = {
	URL_SERVER: process.env.REACT_APP_URL,
	API_URL: process.env.REACT_APP_API,
	PUSHER_ID: process.env.REACT_APP_PUSHER_ID,
	BASE_URL: process.env.REACT_APP_BASE_URL,
	API_MAPS: process.env.REACT_APP_GMAP_API_KEY as string,
	TICKET_IMAGE_URL: process.env.REACT_APP_API+'/storage/upload/ticket/',
	TMP_IMAGE_URL: process.env.REACT_APP_API+'/storage/temp/',
	PER_PAGE_SELECTED: 10,
	NUMBER_ROWS: [10, 15, 25, 50, 100,1000],
	DEBOUNCED_TIMEOUT: 500,
	date_format: 'dd/MM/yyyy HH:mm',
	date_format_type_2: 'dd/MM/yyyy',
};
